import { lazy, Suspense, useEffect, useState } from 'react';

import { env } from '@/lib/env';

const TawkChat = lazy(() =>
  import('@/components/common/TawkChat').then(m => ({ default: m.TawkChat }))
);

export function DeferredTawkChat() {
  const [shouldMount, setShouldMount] = useState(false);

  useEffect(() => {
    if (!env.TAWK_PROPERTY_ID || !env.TAWK_WIDGET_ID) return;

    let idleHandle: number | undefined;
    let timeoutHandle: number | undefined;
    const trigger = () => setShouldMount(true);

    if (typeof window.requestIdleCallback === 'function') {
      idleHandle = window.requestIdleCallback(trigger, { timeout: 3000 });
    } else {
      timeoutHandle = window.setTimeout(trigger, 2500);
    }

    return () => {
      if (idleHandle !== undefined) window.cancelIdleCallback?.(idleHandle);
      if (timeoutHandle !== undefined) window.clearTimeout(timeoutHandle);
    };
  }, []);

  if (!shouldMount) return null;

  return (
    <Suspense fallback={null}>
      <TawkChat />
    </Suspense>
  );
}
